import { FormControl, FormControlLabel, FormControlLabelProps, FormHelperText } from '@mui/material'
import { C1Switch, C1SwitchProps } from 'c1ui'
import { C1FormControlLabelStyles } from 'components/core/RHKFormComponents/C1LabeledSwitchStyles'
import React, { ReactNode } from 'react'
import { Control, Controller } from 'react-hook-form'
import { Message } from 'react-hook-form/dist/types/errors'

type LabelPlacement = FormControlLabelProps['labelPlacement'];

export type C1LabeledSwitchProps = {
    control: Control<any> // eslint-disable-line @typescript-eslint/no-explicit-any
    name: string
    label: ReactNode
    error: boolean
    helperText?: Message
    hideLabel?: boolean
    labelPlacement?: LabelPlacement
} & C1SwitchProps

export const C1LabeledSwitch: React.FC<C1LabeledSwitchProps> = ({
    control,
    name,
    label,
    error,
    helperText,
    hideLabel,
    labelPlacement = 'start',
    ...props
}) => {
    const helperTextId = `${name}-helper-text`
    return <FormControl error={error}>
        <Controller
            name={name}
            control={control}
            render={({ field }): React.ReactElement => (
                <FormControlLabel
                    sx={C1FormControlLabelStyles.root}
                    control={<C1Switch {...field} checked={field.value} aria-describedby={helperTextId} {...props} />}
                    label={!hideLabel ? label : undefined}
                    labelPlacement={labelPlacement}
                />
            )}
        />
        {helperText && <FormHelperText id={helperTextId}>{helperText}</FormHelperText>}
    </FormControl>
}
